// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/three-column-layout","leading":"three-column-layout-m__leading__10E32","trailing":"three-column-layout-m__trailing__1__Yd"};